import { render } from "./DhTableHeader.vue?vue&type=template&id=523da352"
import script from "./DhTableHeader.vue?vue&type=script&lang=ts"
export * from "./DhTableHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script